import * as React from "react";
import { useForm } from "react-hook-form";
// import "./QueryTool.css";

import {
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  TextField,
} from "@mui/material";
import Preview from "../charts/Preview";
import Header2 from "../widgets/header2";
import Breadcrumb from "../../../components/bootstrap/Breadcrumb";
import Button from "../../../components/bootstrap/Button";
import Card, {
  CardActions,
  CardBody,
  CardFooter,
  CardFooterLeft,
  CardFooterRight,
  CardHeader,
  CardLabel,
  CardSubTitle,
  CardTitle,
} from "../../../components/bootstrap/Card";
import Checks from "../../../components/bootstrap/forms/Checks";
import FormGroup from "../../../components/bootstrap/forms/FormGroup";
import Input from "../../../components/bootstrap/forms/Input";
import Select from "../../../components/bootstrap/forms/Select";
import Option from "../../../components/bootstrap/Option";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../../components/ToastComponent";
import { capitalizeAllLetter } from "../common-component/CapitalizeFirstLetter";
import ToastComponent from "../../../components/ToastComponent";
import { isJSONString } from "../../../helpers/isJSONString";
import { any } from "prop-types";
interface QueryParamType {
  qpId: number;
  queryId: number;
  createUser: string;
  lable: string;
  fieldName: string;
  fieldType: string;
}
export default function EditWidget2(props: any) {
  // const EditTabId = sessionStorage.getItem('editTabId');
  // console.log(EditTabId,'-----------------type is',typeof  EditTabId)
  const [id, setId] = React.useState<any>(props.widgetId);
  const form = useForm<FormValues>();
  const { handleSubmit } = form;
  const [datasorces, setDatasorces] = React.useState<any>([]);
  const [queries, setQueries] = React.useState<any>([]);
  const [widgets, setWidgets] = React.useState<any>([]);
  const [QPList, setQpList] = React.useState<QueryParamType[]>([
    {
      qpId: 0,
      queryId: 0,
      createUser: "User",
      lable: "",
      fieldName: "",
      fieldType: "",
    },
  ]);
  const [show, setShow] = React.useState(false);
  const [disabled, setDisabled] = React.useState(true);
  const [previewString, setPreviewString] = React.useState<string>("");
  const [successMessage, setSuccessMessage] = React.useState<string>("");
  const [errorMessage, setErrorMessage] = React.useState<string>("");
  const [viewTypeOptions, setViewTypeOptions] = React.useState<any[]>([]);
  const [selectedViewType, setSelectedViewType] = React.useState<any>([]);
  const [selectedQuery, setSelectedQuery] = React.useState<any>([]);
  const [selectedParent, setSelectedParent] =
    React.useState<any>("Select Parent");
  const [childWidgets, setChildWidgets] = React.useState<any[]>([]);
  const [formData, setFormData] = React.useState<FormValues>({
    name: "",
    selectQuery: 0,
    selectParent: 0,
    createUser: "",
    selectViewType: 0,
  });
  const [exportClick, setExport] = React.useState({
    export: false,
    widgetId: 0,
  });
  const isValid = () => {
    return (
      formData.selectQuery !== "" &&
      formData.selectViewType !== "" &&
      formData.name !== ""
    );
  };
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  React.useEffect(() => {
    fetchwidgetData(id);
    fetchAllWidgetsData();
    fetchQueryData();
    fetchViewTypeData();
    fetchAllChildWidgets(Number(id));
  }, [props, id]);

  type FormValues = {
    name: string;
    selectQuery: any;
    selectParent: any;
    selectViewType: any;
    createUser: string;
  };

  const fetchAllWidgetsData = async () => {
    try {
      const token = localStorage.getItem("token");

      // Make API call to fetch query options
      const response = await fetch(`${vyu_api_url}/widget/getAllWidget`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      console.log(data);
      const widgets = data.obj;
      setWidgets(widgets);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchQueryData = async () => {
    try {
      const token = localStorage.getItem("token");

      // Make API call to fetch query options
      const response = await fetch(`${vyu_api_url}/query/getAllQuery`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      console.log(data);
      const queryOptions = data.obj;
      setQueries(queryOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchViewTypeData = async () => {
    try {
      const token = localStorage.getItem("token");

      // Make API call to fetch query options
      const response = await fetch(`${vyu_api_url}/viewType/getAllViewType`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      console.log(data);
      const viewTypeOptions = data.obj;
      setViewTypeOptions(viewTypeOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const saveWidget = async () => {
    // alert(JSON.stringify(formData))
    console.log(formData);
    console.log("formData.selectQuery", formData.selectQuery);
    console.log("formData.selectViewType", formData.selectViewType);
    if (typeof formData.selectQuery === "object") {
      console.log("formData.selectQuery is an object", formData.selectQuery);
    }
    const token = localStorage.getItem("token");
    const currentUser = JSON.parse(localStorage.getItem("userInfo") || "{}");
    let formDataObject = {
      id: id,
      name: formData.name === "" ? null : capitalizeAllLetter(formData.name),
      queryId:
        formData.selectQuery === 0
          ? null
          : typeof formData.selectQuery === "object"
            ? formData.selectQuery.id
            : JSON.parse(formData.selectQuery),
      parentWidgetId: formData.selectParent.id,
      viewTypeId:
        formData.selectViewType === 0 || formData.selectViewType === ""
          ? null
          : typeof formData.selectViewType === "object"
            ? formData.selectViewType.id
            : JSON.parse(formData.selectViewType),
      updateUser: currentUser.email,
      // name: formData.name === "" ? null : capitalizeAllLetter(formData.name),
      // queryId:
      //   formData.selectQuery === 0 ? null : JSON.parse(formData.selectQuery).id,
      // parentWidgetId: formData.selectParent.id,
      // viewTypeId: JSON.parse(formData.selectViewType).id,
      // updateUser: currentUser.email,
    };

    if (typeof formDataObject.parentWidgetId === "string") {
      formDataObject = {
        ...formDataObject,
      };
    }
    console.log(formDataObject);
    try {
      const response = await fetch(
        `${vyu_api_url}/widget/updateById?id=${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formDataObject),
        }
      );
      if (response.ok) {
        setSuccessMessage("Widget updated successfully!");
        setErrorMessage("");
        handleSuccess("Widget updated successfully!");
      } else {
        setSuccessMessage("");
        const data = await response.json();
        setErrorMessage(data.message || "Failed to update widget!");
        handleError(data.message || "Failed to update widget!");
      }
    } catch (error) {
      console.error("Error updating widget:", error);
      setErrorMessage("An error occurred while updating widget");
    }
    // handleFullReset();
  };
  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };
  const handleChange = (e: any) => {
    setShow(false);
    const { name, value } = e.target;
    console.log(name, "-->", value);
    if (name === "selectParent") {
      const selectedId = parseInt(value);
      const selectedParent = widgetMap.get(selectedId);
      setFormData({
        ...formData,
        [name]: selectedParent,
      });
      return;
    }
    if (name === "selectQuery") {
      console.log("selectQuery in handleChange queries");

      const selectedId = parseInt(value);
      console.log("selectedId in handleChange", selectedId);

      console.log("List of queries being searched:", queries);

      const foundQuery = queries.find((q: any) => q.id === selectedId);
      console.log("selectQueryId in handleChange", foundQuery);
      // const selectQueryId = widgetMap.get(selectedId);
      // console.log("selectQueryId in handleChange", selectQueryId);

      setFormData({
        ...formData,
        [name]: foundQuery,
      });
      return;
    }
    if (name === "selectViewType") {
      console.log("selectViewType in handleChange viewTypeOptions");

      const selectedId = parseInt(value);
      console.log("selectedId in handleChange", selectedId);
      console.log("List of ViewType being searched:", viewTypeOptions);

      const foundViewType = viewTypeOptions.find(
        (q: any) => q.id === selectedId
      );
      console.log("ViewType in handleChange", foundViewType);
      setSelectedViewType(foundViewType.name);
      // const selectViewTypeId = widgetMap.get(selectedId);
      // console.log("selectQueryId in handleChange", selectViewTypeId);

      setFormData({
        ...formData,
        [name]: foundViewType,
      });
      return;
    }
    // if (name === "selectViewType") {
    //   setSelectedViewType(value);
    //   if (formData.selectQuery !== 0) setDisabled(false);
    // }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const widgetMap = React.useMemo(() => {
    const map = new Map<number, { id: number; name: string }>();
    widgets.forEach((w: any) => map.set(w.id, w));
    return map;
  }, [widgets]);

  const fetchAllChildWidgets = async (id: number) => {
    try {
      const token = localStorage.getItem("token");

      // Make API call to fetch child widgets
      const response = await fetch(
        `${vyu_api_url}/widget/getAllChildWidgetForUserAndWidget?widgetId=${id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch Child widget data");
      }
      const data = await response.json();
      const cw = data.obj;
      setChildWidgets(cw);
    } catch (error) {
      console.error("Error fetching Child widget data data:", error);
    }
  };

  const handleExport = (data: any) => {
    setExport(data);
  };
  const handleAfterExport = (data: any) => {
    setExport(data);
  };

  // const getChildWidgetsRecursively = (widgetId : number) =>{
  //   // Filter widgets
  //   let childWidgetsTemp: any[] = widgets.filter((item : any) => item.getParentWidget.id !== widgetId);
  //   if(childWidgetsTemp.length !== 0){
  //     setChildWidgets(prev => [...prev,childWidgetsTemp]);
  //   childWidgets.forEach(child => {
  //     getChildWidgetsRecursively(child.id);
  //   })
  //   }
  // }

  // const filterChildWidgets = (childArray:any[],parentArray:any[]) : any[] =>{
  //   console.log(childArray,parentArray)
  //   let filterdArray : any[]  = parentArray.filter( ar => !childArray.find( rm => rm.id === ar.id));
  //   console.table(filterdArray)
  //   return filterdArray;
  // }

  // const filterWidgets = (widgetId : number) : any[] =>{
  //   getChildWidgetsRecursively(widgetId);
  //   let filteredWidgets : any[] = filterChildWidgets(childWidgets,widgets);
  //   setWidgets(filteredWidgets);
  //   console.table(filteredWidgets)
  //   return filteredWidgets;
  // }

  const onSubmit = () => {
    saveWidget();
  };
  const [print, setPrint] = React.useState(false);
  const [printObj, setPrintObj] = React.useState({
    print: false,
    viewType: "Pie Chart",
  });
  const handlePrint = (obj: any) => {
    setPrint(obj.print);
    setPrintObj(obj);
    console.log(obj);
  };
  function handlePreview(): any {
    setShow((prev) => !prev);
  }

  const fetchwidgetData = async (id: number) => {
    const token = localStorage.getItem("token");
    const response: Response = await fetch(
      `${vyu_api_url}/widget/getById?id=${id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    console.log("Data inside fetch widget data is: ", data);
    setFormData({
      createUser: data.createUser,
      name: data.name,
      selectParent: data.parentWidget ? data.parentWidget : "null parent",
      selectViewType: data.viewTypeId,
      selectQuery: data.queryId,
    });
    setSelectedViewType(data.viewTypeId.name);
    setSelectedQuery(data.queryId.name);
    setSelectedParent(data.parentWidget?.name);
    setDisabled(false);
  };
  const inputStyle =
    "form-control block w-full px-3 py-2 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-md transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none";
  const selectStyle = "form-select " + inputStyle;
  const smallRadius = { borderRadius: "4px", borderColor: "#E0E0E0" };

  return (
    <div className="column">
      <div className="col-lg-12">
        <Card stretch style={{ borderRadius: "4px" }}>
          <CardBody>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormGroup label="Widget Name">
                  <span style={{ color: "red", marginRight: 4 }}>*</span>
                  <Input
                    // className="shadow-md italic w-full h-10 mb-6"
                    style={smallRadius}
                    className={inputStyle}
                    // fullWidth
                    // variant="outlined"
                    id="name"
                    name="name"
                    placeholder="Enter name of the widget"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </FormGroup>
              </div>
              <div className="col-md-6 mb-4">
                <FormGroup label="Select Query">
                  <span style={{ color: "red", marginRight: 4 }}>*</span>
                  <Select
                    // className="shadow-md italic w-full h-10 appearance-auto mb-6"
                    style={smallRadius}
                    className={selectStyle}
                    id="selectQuery"
                    ariaLabel="selectQuery"
                    name="selectQuery"
                    placeholder="Select Query"
                    value={formData.selectQuery?.id ?? ""}
                    onChange={handleChange}
                  >
                    {queries.map((item: { id: number; name: string }) => (
                      <Option className="italic" key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </FormGroup>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormGroup label="Select Parent">
                  <Select
                    ariaLabel="Select Parent"
                    placeholder="Select Parent"
                    // className="shadow-md italic w-full h-10 appearance-auto mb-6"
                    style={smallRadius}
                    className={selectStyle}
                    id="selectParent"
                    name="selectParent"
                    value={formData.selectParent?.id ?? ""}
                    onChange={handleChange}
                  >
                    {widgets.map((item: { id: number; name: string }) => (
                      <Option className="italic" key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </FormGroup>
              </div>

              <div className="col-md-6 mb-4">
                <FormGroup label="Select View Type">
                  <span style={{ color: "red", marginRight: 4 }}>*</span>
                  <Select
                    ariaLabel="selectViewType"
                    placeholder="Select View Type"
                    // className="shadow-md italic w-full h-10 appearance-auto mb-6"
                    style={smallRadius}
                    className={selectStyle}
                    id="selectViewType"
                    name="selectViewType"
                    value={formData.selectViewType?.id ?? ""}
                    onChange={handleChange}
                  >
                    {viewTypeOptions.map(
                      (item: { id: number; name: string }) => (
                        <Option
                          className="italic"
                          key={item.id}
                          value={item.id}
                        >
                          {item.name}
                        </Option>
                      )
                    )}
                  </Select>
                </FormGroup>
              </div>
            </div>
          </CardBody>

          <CardFooter>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "8px",
              }}
            >
              <form onSubmit={handleSubmit(onSubmit)}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                  }}
                >
                  {/* <CardHeader>
                    <div
                      className="flex items-center"
                      style={{ display: "flex" }}
                    >
                      <Checks
                        disabled={!isValid()}
                        onChange={handlePreview}
                        checked={show}
                        type="checkbox"
                        aria-label="pr"
                        style={{ backgroundColor: "#6c757d" }}
                      />
                      <CardTitle style={{ fontSize: "16px" }}>
                        Preview
                      </CardTitle>
                    </div>
                  </CardHeader> */}
                  <Button
                    isLight={true}
                    className="reset-button"
                    style={{ border: "1px solid #d0d5dd" }}
                    type="button"
                    onClick={handlePreview}
                    isDisable={!isValid()}
                  >
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.116 16C1.67133 16 1.291 15.8417 0.975 15.525C0.659 15.2083 0.500667 14.8287 0.5 14.386V1.615C0.5 1.171 0.658333 0.791 0.975 0.475C1.29167 0.159 1.67167 0.000666667 2.115 0H14.885C15.329 0 15.709 0.158333 16.025 0.475C16.341 0.791667 16.4993 1.17167 16.5 1.615V14.385C16.5 14.829 16.3417 15.209 16.025 15.525C15.7083 15.841 15.3283 15.9993 14.885 16H2.116ZM2.116 15H14.885C15.0643 15 15.2117 14.9423 15.327 14.827C15.4423 14.7117 15.5 14.5643 15.5 14.385V3H1.5V14.385C1.5 14.5643 1.55767 14.7117 1.673 14.827C1.78833 14.9423 1.936 15 2.116 15ZM8.5 12C7.41533 12 6.438 11.722 5.568 11.166C4.698 10.6107 4.04067 9.88867 3.596 9C4.04067 8.11133 4.698 7.38933 5.568 6.834C6.438 6.278 7.41533 6 8.5 6C9.58467 6 10.562 6.278 11.432 6.834C12.302 7.39 12.9593 8.112 13.404 9C12.9593 9.88867 12.302 10.6107 11.432 11.166C10.562 11.722 9.58467 12 8.5 12ZM8.496 10.116C8.18467 10.116 7.92133 10.007 7.706 9.789C7.492 9.571 7.385 9.30667 7.385 8.996C7.385 8.68467 7.49367 8.42133 7.711 8.206C7.929 7.992 8.19333 7.885 8.504 7.885C8.81533 7.885 9.07867 7.99367 9.294 8.211C9.50867 8.429 9.616 8.69333 9.616 9.004C9.616 9.31533 9.507 9.57867 9.289 9.794C9.071 10.0087 8.80667 10.116 8.496 10.116ZM8.5 10.885C9.02 10.885 9.46433 10.701 9.833 10.333C10.2017 9.965 10.3857 9.52067 10.385 9C10.3843 8.47933 10.2003 8.035 9.833 7.667C9.465 7.299 9.02067 7.115 8.5 7.115C7.97933 7.115 7.535 7.299 7.167 7.667C6.799 8.035 6.615 8.47933 6.615 9C6.615 9.52067 6.799 9.965 7.167 10.333C7.535 10.701 7.97933 10.885 8.5 10.885Z"
                        fill="#0D57DE"
                      />
                    </svg>
                    <span style={{ fontSize: "12px" }}>Preview</span>
                  </Button>
                  <Button
                    isLight={true}
                    // color="primary"
                    // className="m-1"
                    className="signin-button"
                    style={{ border: "1px solid #d0d5dd" }}
                    type="submit"
                    isDisable={!isValid()}
                  >
                    <span style={{ fontSize: "12px" }}>Submit</span>
                  </Button>
                </div>
              </form>
            </div>
          </CardFooter>
        </Card>
      </div>
      <div className="col-lg-12">
        <Card stretch style={{ borderRadius: "4px" }}>
          <CardBody>
            {show && (
              <div className="items-center flex flex-col">
                <div className="justify-center text-blue-600 text-center">
                  <h3>{previewString}</h3>
                </div>
                <div className="flex items-center justify-center ">
                  <Card style={{ width: "100%", height: "100%" }}>
                    <Header2
                      name={formData.name}
                      print={print}
                      parentCallback={handlePrint}
                      viewType={selectedViewType}
                      widgetData={formData.selectQuery}
                      exportCallback={handleExport}
                    ></Header2>
                    <Preview
                      viewType={
                        typeof selectedViewType === "string"
                          ? selectedViewType
                          : selectedViewType
                      }
                      widgetData={formData.selectQuery}
                      previewType={"EditWidget"}
                      widgetName={formData.name}
                      printObj={printObj}
                      exportClick={exportClick}
                      exportAfterCallback={handleAfterExport}
                    />
                  </Card>
                </div>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      <ToastComponent />
    </div>
  );
}
function setViewTypeOptions(viewTypeOptions: any) {
  throw new Error("Function not implemented.");
}
